const c = {
  name: "Apple",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,0h-2v9.6C17.1,7.9,14.6,7,12,7c-2.8,0-5.5,1.1-7.6,3.1C1.6,13,0,16.8,0,20.9c0,2.2,0.5,4.4,1.4,6.4
			l3.4,7.2c1.6,3.4,5,5.5,8.7,5.5c2.5,0,4.8-0.9,6.6-2.6c1.8,1.7,4.1,2.6,6.5,2.6h0h0h0c3.7,0,7.1-2.2,8.7-5.5l3.4-7.2
			c0.9-2,1.4-4.2,1.4-6.4c0-4-1.6-7.8-4.5-10.7c-1-1-2.2-1.8-3.5-2.3c1.8-1.1,2.8-2.7,2.8-2.8l0.3-0.5L34.9,4c-0.1-0.2-2.5-4-6.8-4
			s-6.8,3.8-6.9,4L21,4.2V0z M21,4.8v4.8c0.9-0.8,1.9-1.4,3-1.8c-1.8-1.1-2.7-2.7-2.8-2.8L21,4.8z M20,34.6L20,34.6l-1.2,1.2
			c-1.4,1.4-3.3,2.2-5.3,2.2c-2.9,0-5.6-1.7-6.9-4.4l-3.4-7.2C2.4,24.7,2,22.8,2,20.9c0-3.5,1.4-6.8,3.9-9.3C7.5,9.9,9.7,9,12,9
			c2.3,0,4.5,0.9,6.1,2.5l1.9,1.9l1.9-1.9C23.5,9.9,25.7,9,28,9s4.5,0.9,6.2,2.6c2.5,2.5,3.8,5.8,3.8,9.3c0,1.9-0.4,3.8-1.2,5.6
			l-3.4,7.2c-1.2,2.7-3.9,4.4-6.9,4.4c-2,0-3.9-0.8-5.4-2.2L20,34.6z M28,7c-2.4,0-4-1.6-4.8-2.5C24,3.6,25.7,2,28,2s4,1.6,4.8,2.5
			C32,5.4,30.4,7,28,7z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Apple
};
